<template>
  <!-- 个人介绍 -->
  <base-panel>
    <slot>
      <div class="author-info">
        <div
          class="author-head"
          :style="{
            backgroundImage: `url(${authorInfo.headPic})`
          }"
        ></div>
        <div class="author-name">{{ authorInfo.name }}</div>
        <div class="author-type-name">
          {{ authorInfo.typeName }} |
          {{ authorInfo.authorCompany }}
        </div>
        <div class="author-fans">粉丝数 {{ authorInfo.followerNum }}</div>
        <el-tag
          v-for="(item, index) in authorInfo.tagSkill"
          :key="index"
          class="skill-tag"
        >{{ item }}</el-tag>
        <el-button
          class="follow"
          type="primary"
          :class="{ followed: isFollowed }"
          :loading="following"
          @click="follow(isFollowed)"
        ></el-button>
      </div>
    </slot>
  </base-panel>
</template>

<script>
import BasePanel from '@/components/BasePanel/BasePanel'
import { mapActions } from 'vuex'
import { followAuthor } from '@/api/account'
export default {
  name: 'AuthorInfoPanel',
  components: { BasePanel },
  props: {
    authorInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      following: false,
      isFollowed: false
    }
  },
  watch: {
    authorInfo: {
      immediate: true,
      handler(val) {
        this.isFollowed = val.isFollowed
      }
    }
  },
  methods: {
    async follow(isFollowed) {
      const inLogin = await this.ensureLogin()
      if (inLogin) {
        this.following = true
        const detail = await followAuthor(
          this.authorInfo.authorId,
          +!isFollowed
        )

        this.following = false

        if (detail) {
          this.isFollowed = !isFollowed
        }
      }
    },
    ...mapActions({
      ensureLogin: 'auth/ensureLogin'
    })
  }
}
</script>

<style lang="scss" scoped>
.author-info {
  text-align: center;
}

.author-head {
  width: 60px;
  height: 60px;
  margin: 30px auto 20px;
  background: no-repeat center;
  background-size: contain;
  border-radius: 50%;
}

.author-name {
  font-size: 16px;
  color: #262626;
}

.author-type-name {
  margin-top: 20px;
  font-size: 14px;
  color: #858585;
}

.author-fans {
  margin: 20px 0 20px;
  font-size: 14px;
  color: #858585;
}

.follow {
  width: 100%;
  border-radius: 0;
  margin-top: 24px;
  border: none;

  &::after {
    content: '关注';
  }
}

.followed {
  background-color: #ebebeb;
  color: #858585;

  &::after {
    content: '已关注';
  }
}

.skill-tag {
  margin: 0 7px;
}
</style>
